import React from "react";
import { Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import get from "lodash.get";
import messages from "../views/Dashboard/Dashboard.messages";

// Services
import { jobGetJob } from "../services/job";
import useFormatter from "../hooks/useFormatter";
import { injectIntl } from "react-intl";
import useEnv from "../hooks/useEnv";

const ReturnPaymentStep2 = (props) => {
    const { formatCurrency } = useFormatter();
    const { getEnv } = useEnv();
    const job = jobGetJob();
    const lng = props.intl.formatMessage;

    const currency = (job?.currency && job.currency !== '') ? job.currency : getEnv('DEFAULT_CURRENCY');
    
    
    return (
        <>
            <Row>
                <p className='text-dark'>{ lng(messages.paymentReturnDetailsDescription) }</p>
            </Row>
            <Row>
                <h4 className='mt-4 mb-4'>{ lng(messages.paymentReturnDetailsTitle) }</h4>
            </Row>
            <Row as="section" aria-labelledby="return-payment-details-list">
                <ul
                    className="list-unstyled vertically-centered-items"
                    id="return-payment-details-list"
                >
                    <li>
                        <Row>
                            <Col xs={6}>
                                <p className="fw-bold" id="return-amount-label">
                                    {lng(messages.returnAmount)}
                                </p>
                            </Col>
                            <Col xs={6}>
                                <p
                                    className="float-end text-end text-dark"
                                    aria-labelledby="return-amount-label"
                                >
                                    {formatCurrency(job.modoverpaidamount, currency)}
                                </p>
                            </Col>
                        </Row>
                    </li>
                    <li>
                        <Row>
                            <Col xs={6}>
                                <p className="fw-bold" id="refund-processing-fee-label">
                                    {lng(messages.refundProcessingFee)}
                                </p>
                            </Col>
                            <Col xs={6}>
                                <p
                                    className="float-end text-end text-dark"
                                    aria-labelledby="refund-processing-fee-label"
                                >
                                    {formatCurrency(job.modoverpaidfee, currency)}
                                </p>
                            </Col>
                        </Row>
                    </li>
                    <li>
                        <Row>
                            <Col xs={6}>
                                <p className="fw-bold" id="reference-label">
                                    {lng(messages.reference)}
                                </p>
                            </Col>
                            <Col xs={6}>
                                <p
                                    className="float-end text-end text-dark"
                                    aria-labelledby="reference-label"
                                >
                                    {job.reference}
                                </p>
                            </Col>
                        </Row>
                    </li>
                    <li>
                        <Row>
                            <Col xs={6}>
                                <p className="fw-bold" id="case-number-label">
                                    {lng(messages.caseNumber)}
                                </p>
                            </Col>
                            <Col xs={6}>
                                <p
                                    className="float-end text-end text-dark"
                                    aria-labelledby="case-number-label"
                                >
                                    {job.jobid}
                                </p>
                            </Col>
                        </Row>
                    </li>
                </ul>
            </Row>
        </>
    );
};

ReturnPaymentStep2.propTypes = {
    'intl': PropTypes.object.isRequired
};

export default injectIntl(ReturnPaymentStep2);
